import { render, staticRenderFns } from "./TeamListingItem.vue?vue&type=template&id=2b035689&scoped=true&"
import script from "./TeamListingItem.vue?vue&type=script&lang=js&"
export * from "./TeamListingItem.vue?vue&type=script&lang=js&"
import style0 from "./TeamListingItem.vue?vue&type=style&index=0&id=2b035689&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b035689",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/TeamListingItem.vue
// module id = 384
// module chunks = 0